import React from "react";
import styled, { css } from "styled-components";
const StyledLoaderWrapper = styled.div `
  opacity: ${props => (props.isLoading ? "0" : "1")};
  transition: all 0.3s ease-in-out;
  width: 100%;

  ${props => props.isFlex &&
    css `
      display: flex;
    `};
`;
const Loader = ({ children, isLoading, loader, isFlex, className }) => {
    if (isLoading) {
        return loader;
    }
    return (React.createElement(StyledLoaderWrapper, { className: className, isLoading: isLoading, isFlex: isFlex }, children));
};
export default Loader;
